import type { UserMessageData } from "app/pages/sales-intelligence/modules/ai-agent/store";
import type { ILeadsSearchFiltersDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import type { ContactProfileDtoList } from "app/pages/sales-intelligence/sub-modules/contacts-search-profiles/types/dto";
import type Signal from "app/pages/sales-intelligence/sub-modules/signals/models/core/Signal";

export type InputFiltersStatePayload = {
    readonly inputFiltersState: Partial<ILeadsSearchFiltersDto>;
};

export type FiltersStatePayload = {
    readonly filtersState: Partial<ILeadsSearchFiltersDto>;
};

type SignalsStatePayload = {
    readonly signals: readonly Signal[];
};

type ContactPersonaStatePayload = {
    readonly employeeProfiles: ContactProfileDtoList;
};

export enum ApplicationStateChangeType {
    FilterListChange = "filter-list-change",
    EmployeeProfileListChange = "employee-profile-list-change",
    SignalsListChange = "signals-list-change",
    SignalDraftCreateAndApply = "signal-draft-create-and-apply",
    SignalLifecycleChange = "signal-lifecycle-change",
}

type AppStateContext = {
    readonly changeType: ApplicationStateChangeType;
};

export interface IApplicationStatePayload {
    readonly state: FiltersStatePayload | SignalsStatePayload | ContactPersonaStatePayload;
    readonly context: AppStateContext;
}

export type LeadGeneratorAgentPayload = UserMessageData<Partial<InputFiltersStatePayload | IApplicationStatePayload>>;

export type LeadGeneratorAgentMessagePayload = LeadGeneratorAgentPayload & {
    readonly threadId: string;
};

export type CreateThreadResponse = {
    readonly threadId: string;
};

export type LeadGeneratorThreadData = {
    threadId: string;
    messageId: string;
    content: string;
    createdAt: string;
};
